<template>
  <v-dialog
    v-bind="{ ...$props, ...$attrs }"
    fullscreen
    :content-class="`similar-jobs-modal-content${isDatapeopleAnywhereView ? ' is-dpa' : ''}`"
    @click:outside="$emit('close')"
  >
    <v-card
      max-width="100%"
      max-height="90vh"
      class="modal-with-pages-card"
    >
      <div
        v-if="loading"
        class="flex-grow-1 d-flex align-center justify-center"
      >
        <v-progress-circular
          class="mx-auto modal-loader"
          indeterminate
          color="brandPrimary"
          size="100"
          width="10"
          data-testid="full-modal-loader"
        />
      </div>
      <div v-else>
        <div class="modal-with-pages-content">
          <PageTurner
            v-bind="{
              page, totalPages, reversePages, pageEnds,
            }"
            :close-icon="true"
            :is-modal="true"
            @next-page="$emit('nextPage')"
            @prev-page="$emit('prevPage')"
            @close="$emit('close')"
          >
            <template #title>
              <h5>
                <slot name="title" />
              </h5>
            </template>

            <template #pagedContent>
              <slot name="paged" />
            </template>
          </PageTurner>
          <slot name="static" />
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import PageTurner from '@/components/shared/PageTurner.vue';

export default {
  name: 'ModalWithPages',
  components: { PageTurner },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    reversePages: {
      type: Boolean,
      default: false,
    },
    pageEnds: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  emits: ['nextPage', 'prevPage', 'close'],
  computed: {
    isDatapeopleAnywhereView() {
      return this.$route?.query.view === 'chrome';
    },
  },
};
</script>

<style lang="less" scoped>
.datapeople-app .modal-with-pages-card {
  width: 100%;
}
.modal-with-pages-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  * {
    user-select: none;
  }
}
.modal-loader {
  margin: 250px 0px;
}
</style>

<style lang="less">
.v-overlay__content.similar-jobs-modal-content {
  border-radius: 10px !important;
  &.is-dpa .page-turner-header-close {
    margin-right: 132px;
  }
}
</style>
